import { getInvoiceBalance } from "../../Utils/PaymentUtils";

export const initialState = {
  newAccount: {},
  accounts: [],
  accountID: "",
  accountLoading: false,
  debitLoading: false,
  debitError: null,
  debits: [],
  deletedID: "",
  deleteLoading: false,
  deleteError: null,
  creditLoading: false,
  creditError: null,
  credits: [],
  initAccountLoading: false,
  initAccountStatus: "",
  inputError: null,
  submitError: null,
  submitLoading: false,
  loading: false,
  transactions: [],
  transactionID: "",
  transaction: {},
  journalLoading: false,
  journalTransactions: [],
  journalError: null,
  journalNextTokens: { 1: null },
  journalNextLoading: false,
  journalNextError: null,
  nextTokens: { 1: null },
  accountNextTokens: { 1: null },
  errorAccount: null,
  balanceAccounts: [],
  balanceLoading: false,
  balanceError: false,
  balanceExportFile: {},
  balanceExportLoading: false,
  balanceExportError: null,
  incomeStatementAccounts: [],
  incomeStatementSummary: {},
  incomeStatementLoading: false,
  incomeStatementError: false,
  incomeExportFile: {},
  incomeExportLoading: false,
  incomeExportError: null,
  vatRecap: null,
  vatRecapPeriod: null,
  vatRecapLoading: false,
  vatRecapError: null,
  vatRecapExportFile: {},
  vatRecapExportLoading: false,
  vatRecapExportError: null,
  capitalAccounts: [],
  capitalLoading: false,
  capitalError: null,
  capitalExportFile: {},
  capitalExportLoading: false,
  capitalExportError: null,
  netIncome: 0,
  capital: 0,
  capitalBeginning: 0,
  capitalRetainedPrior: 0,
  capitalNetIncomeCurrent: 0,
  capitalAdditions: 0,
  capitalWithdrawals: 0,
  capitalMatrix: null,
  cashFlowItems: [],
  cashFlowTransactions: [],
  cashFlowTransactionsTotal: 0,
  cashFlowTransactionsTotalPages: 1,
  cashFlow: 0,
  previousDate: "",
  previousCash: 0,
  endDate: "",
  endCash: 0,
  cashFlowReconciled: true,
  cashFlowDifference: 0,
  cashFlowNonCash: [],
  cashFlowLoading: false,
  cashFlowError: null,
  cashFlowExportFile: {},
  cashFlowExportLoading: false,
  cashFlowExportError: null,
  parentTransaction: {},
  parentTransactionLoading: false,
  parentTransactionError: null,
  uploadLoading: false,
  uploadError: null,
  uploadSuccess: false,
  excelUpload: {},
  storageRequest: null,
  uploadRequest: null,
  uploadStatusError: false,
  excelAccounts: [],
  excelAccountsLoading: false,
  excelAccountsSuccess: false,
  excelAccountsError: null,
  balanceSheets: [],
  balanceSheetsLoading: false,
  balanceSheetsError: null,
  balanceSheetExport: {},
  balanceSheetExportLoading: false,
  balanceSheetExportError: null,
  partnerTransactionsLoading: false,
  partnerTransactionsError: null,
  partnerTransactions: [],
  partnerTransactionsNextTokens: { 1: null },
  newInvoiceID: "",
  newInvoiceError: null,
  newInvoiceLoading: false,
  invoiceID: "",
  allAccountLoading: false,
  downloadInvoice: {},
  downloadInvoiceLoading: false,
  downloadInvoiceError: null,
  accountingSummary: {},
  accountingSummaryLoading: false,
  accountingSummaryError: null,
  generalJournalFile: {},
  generalJournalFileLoading: false,
  generalJournalFileError: null,
  generalJournalSummary: null,
  generalJournalSummaryLoading: false,
  generalJournalSummaryError: null,
  generalJournalSummaryRequest: null,
  excelUploadError: null,
  // Row numbers /upload/transaction refused on period grounds, and the boundary
  // it measured them against. Both live at the top of that 200 response rather
  // than inside excelUploadError, which is why they get their own keys.
  excelUploadClosedRows: null,
  excelUploadClosedThrough: null,
  excelTransactions: [],
  excelTransactionsLoading: false,
  excelTransactionsError: null,
  excelTransactionsSuccess: false,
  transactionInitialData: null,
  draftImport: {},
  draftImportLoading: false,
  draftImportError: null,
  draftImports: [],
  draftImportsLoading: false,
  draftImportsError: null,
  incomeStats: {},
  incomeStatsLoading: false,
  incomeStatsError: null,
  expenseStats: {},
  expenseStatsLoading: false,
  expenseStatsError: null,
  accountingStats: {},
  accountingStatsError: null,
  accountingStatsLoading: false,
  cashFlows: {},
  cashFlowsError: null,
  cashFlowsLoading: false,
  accountTransactions: [],
  accountTransactionsLoading: false,
  accountTransactionsError: null,
  accountTransactionNextTokens: { 1: null },
  accountBalances: {},
  accountBalancesLoading: false,
  accountBalancesError: null,
  // Period lock, keyed by businessID. Keyed rather than a single slot because v1
  // resolves the business from a query param that differs per page, so two
  // surfaces on one screen can ask about different businesses; a single slot
  // would flip between them and mis-lock rows.
  periodStatus: {},
  periodHistory: {},
  periodLoading: false,
  periodError: null,
  // Dedicated write flags: submitLoading/submitError are shared by every
  // accounting mutation, which is what forces InitAccountPromptModal to keep a
  // local `attempted` guard. Closing the books must not inherit that.
  closePeriodLoading: false,
  closePeriodError: null,
  closePeriodResult: null,
  reopenPeriodLoading: false,
  reopenPeriodError: null,
  reopenPeriodResult: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_CREATE_ACCOUNT":
      return {
        ...state,
        newAccount: {},
        error: null,
        loading: true,
      };
    case "SUCCESS_CREATE_ACCOUNT":
      return {
        ...state,
        newAccount: action.payload.account,
        loading: false,
      };
    case "ERROR_CREATE_ACCOUNT":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case "REQUEST_LIST_ACCOUNT":
      return {
        ...state,
        accountLoading: true,
        accountError: null,
        accounts: [],
        request: action.payload.request,
        accountNextTokens:
          action.payload.page === 1
            ? initialState.accountNextTokens
            : state.accountNextTokens,
      };
    case "REQUEST_LIST_ALL_ACCOUNT":
      return {
        ...state,
        // Never downgrade: requestListAccount already dispatched
        // REQUEST_LIST_ACCOUNT (accountLoading true) before the paging loop, so
        // flipping this to false here — while `accounts` is wiped to [] between
        // pages — makes consumers read the state as "settled and empty".
        accountLoading: action.payload.loadAllLoading || state.accountLoading,
        allAccountLoading: true,
        accountError: null,
        accounts: [],
        request: action.payload.request,
        accountNextTokens:
          action.payload.page === 1
            ? initialState.accountNextTokens
            : state.accountNextTokens,
      };
    case "LIST_ACCOUNT_SUCCESS":
      return {
        ...state,
        accountLoading: false,
        allAccountLoading: false,
        accounts: action.payload.items,
        accountNextTokens: {
          ...state.accountNextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
      };
    case "LIST_ACCOUNT_ERROR":
      return {
        ...state,
        accountLoading: false,
        // Cleared here too: a failed loadAll would otherwise leave this true
        // forever and keep the dependent submit buttons disabled.
        allAccountLoading: false,
        accountError: action.error,
      };
    case "REQUEST_CREATE_ACCT_ACCOUNT":
      return {
        ...state,
        request: action.payload.request,
        submitLoading: true,
        submitError: null,
        inputError: null,
        accountID: "",
      };
    case "CREATE_ACCT_ACCOUNT_SUCCESS":
      return {
        ...state,
        request: null,
        submitLoading: false,
        accountID: action.payload.account.id,
        accounts: [action.payload.account, ...state.accounts].sort((a, b) => {
          const dateA = a.createdAt;
          const dateB = b.createdAt;
          if (dateA > dateB) {
            return -1;
          }
          if (dateA < dateB) {
            return 1;
          }
          return 0;
        }),
      };
    case "CREATE_ACCT_ACCOUNT_ERROR":
      return {
        ...state,
        request: null,
        submitLoading: false,
        submitError: action.error,
        // A cancelled request dispatches no payload.
        inputError: action.payload?.errors ?? null,
      };
    case "REQUEST_UPDATE_ACCOUNT":
      return {
        ...state,
        request: action.payload.request,
        submitLoading: true,
        submitError: null,
        accountID: "",
      };
    case "UPDATE_ACCOUNT_SUCCESS":
      const { account } = action.payload;
      const updatedAccountsUpdate = state.accounts.map((accountItem) =>
        accountItem.id === account.id ? account : accountItem,
      );

      return {
        ...state,
        request: null,
        submitLoading: false,
        accountID: account.id,
        accounts: updatedAccountsUpdate,
      };
    case "UPDATE_ACCOUNT_ERROR":
      return {
        ...state,
        request: null,
        submitLoading: false,
        submitError: action.error,
      };
    case "REQUEST_DELETE_ACCOUNT":
      return {
        ...state,
        request: action.payload.request,
        deleteLoading: true,
        deleteError: null,
        deletedID: "",
      };
    case "DELETE_ACCOUNT_SUCCESS":
      return {
        ...state,
        request: null,
        deleteLoading: false,
        deletedID: action.payload.accountID,
        accounts: state.accounts.filter(
          (account) => account.id !== action.payload.accountID,
        ),
      };
    case "DELETE_ACCOUNT_ERROR":
      return {
        ...state,
        request: null,
        deleteLoading: false,
        deleteError: action.error,
      };
    case "REQUEST_LIST_ACCOUNT_CATEGORY":
      return {
        ...state,
        accountCategoryLoading: true,
        accountCategoryError: null,
        accountsCategory: [],
        request: action.payload.request,
      };
    case "LIST_ACCOUNT_CATEGORY_SUCCESS":
      return {
        ...state,
        accountCategoryLoading: false,
        accountsCategory: action.payload.items,
      };
    case "LIST_ACCOUNT_CATEGORY_ERROR":
      return {
        ...state,
        accountCategoryLoading: false,
        accountCategoryError: action.error,
      };
    case "CLEAR_LIST_ACCOUNT":
      return {
        ...state,
        accounts: [],
      };
    case "CLEAR_LIST_ACCOUNT_CATEGORY":
      return {
        ...state,
        accountsCategory: [],
      };
    case "REQUEST_LIST_JOURNAL_TRANSACTION":
      return {
        ...state,
        request: action.payload.request,
        journalTransactions: [],
        journalNextTokens:
          action.payload.page === 1
            ? initialState.journalNextTokens
            : state.journalNextTokens,
        journalLoading: true,
        journalError: null,
      };
    case "LIST_JOURNAL_TRANSACTION_SUCCESS":
      return {
        ...state,
        journalTransactions: action.payload.transactions,
        journalNextTokens: {
          ...state.journalNextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
        journalLoading: false,
        request: null,
      };
    case "LIST_JOURNAL_TRANSACTION_ERROR":
      return {
        ...state,
        journalLoading: false,
        journalError: action.error,
        request: null,
      };
    case "REQUEST_LIST_NEXT_JOURNAL_TRANSACTION":
      return {
        ...state,
        request: action.payload.request,
        journalNextTokens:
          action.payload.page === 1
            ? initialState.journalNextTokens
            : state.journalNextTokens,
        journalNextLoading: true,
        journalNextError: null,
      };
    case "LIST_NEXT_JOURNAL_TRANSACTION_SUCCESS":
      return {
        ...state,
        journalTransactions: [
          ...state.journalTransactions,
          ...action.payload.transactions,
        ],
        journalNextTokens: {
          ...state.journalNextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
        journalNextLoading: false,
        request: null,
      };
    case "LIST_NEXT_JOURNAL_TRANSACTION_ERROR":
      return {
        ...state,
        journalNextLoading: false,
        journalNextError: action.error,
        request: null,
      };
    case "REQUEST_LIST_ACCOUNTING_TRANSACTION":
      return {
        ...state,
        request: action.payload.request,
        transactions: [],
        nextTokens:
          action.payload.page === 1
            ? initialState.nextTokens
            : state.nextTokens,
        nextToken: null,
        loading: true,
        error: null,
      };
    case "LIST_ACCOUNTING_TRANSACTION_SUCCESS":
      return {
        ...state,
        transactions: action.payload.transactions,
        nextTokens: {
          ...state.nextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
        loading: false,
        request: null,
      };
    case "LIST_ACCOUNTING_TRANSACTION_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
        request: null,
      };
    case "REQUEST_INIT_ACCOUNT":
      return {
        ...state,
        request: action.payload.request,
        submitError: null,
        initAccountLoading: true,
        initAccountStatus: "",
      };
    case "INIT_ACCOUNT_SUCCESS":
      return {
        ...state,
        request: null,
        initAccountLoading: false,
        initAccountStatus: "SUCCESS",
      };
    case "INIT_ACCOUNT_ERROR":
      return {
        ...state,
        request: null,
        initAccountLoading: false,
        submitError: action.error,
      };
    case "CLEAR_INIT_ACCOUNT_STATUS":
      return {
        ...state,
        initAccountStatus: "",
      };
    case "REQUEST_LIST_CREDIT_ACCOUNT":
      return {
        ...state,
        creditLoading: true,
        creditError: null,
        credits: [],
        creditAccountRequest: action.payload.creditAccountRequest,
      };
    case "CLEAR_ACCOUNTING_TRANSACTION":
      return {
        ...state,
        transaction: {},
        transactionID: "",
        deletedID: "",
      };
    case "CLEAR_ACCT_TRANSACTION_ERROR":
      return {
        ...state,
        submitError: null,
        nextError: null,
      };
    case "LIST_CREDIT_ACCOUNT_SUCCESS":
      return {
        ...state,
        creditAccountRequest: null,
        creditLoading: false,
        credits: action.payload.items,
      };
    case "LIST_CREDIT_ACCOUNT_ERROR":
      return {
        ...state,
        creditAccountRequest: null,
        creditLoading: false,
        creditError: action.error,
      };
    case "REQUEST_LIST_DEBIT_ACCOUNT":
      return {
        ...state,
        debitLoading: true,
        debitError: null,
        debits: [],
        debitAccountRequest: action.payload.debitAccountRequest,
      };
    case "LIST_DEBIT_ACCOUNT_SUCCESS":
      return {
        ...state,
        debitAccountRequest: null,
        debitLoading: false,
        debits: action.payload.items,
      };
    case "LIST_DEBIT_ACCOUNT_ERROR":
      return {
        ...state,
        debitAccountRequest: null,
        debitLoading: false,
        debitError: action.error,
      };
    case "REQUEST_GET_ACCOUNTING_TRANSACTION":
      return {
        ...state,
        request: action.payload.request,
        transaction: {},
        loading: true,
        error: null,
      };
    case "GET_ACCOUNTING_TRANSACTION_SUCCESS":
      const { transaction: updatedTransaction } = action.payload;
      const updatedTransactionsGet = state.transactions.map(
        (transactionItem) =>
          transactionItem.id === updatedTransaction?.id
            ? updatedTransaction
            : transactionItem,
      );
      return {
        ...state,
        transaction: updatedTransaction,
        transactions: updatedTransactionsGet,
        loading: false,
        request: null,
      };
    case "REFRESH_ACCT_TRANSACTION_SUCCESS": {
      const { transaction: refreshed } = action.payload;
      return {
        ...state,
        transactions: state.transactions.map((item) =>
          item.id === refreshed.id ? refreshed : item,
        ),
        transaction:
          state.transaction?.id === refreshed.id
            ? refreshed
            : state.transaction,
      };
    }
    case "GET_ACCOUNTING_TRANSACTION_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
        request: null,
      };
    case "REQUEST_GET_PARENT_ACCT_TRANSACTION":
      return {
        ...state,
        request: action.payload.request,
        parentTransaction: {},
        parentTransactionLoading: true,
        parentTransactionError: null,
      };
    case "SUCCESS_GET_PARENT_ACCT_TRANSACTION":
      return {
        ...state,
        parentTransaction: action.payload.parentTransaction,
        parentTransactionLoading: false,
        request: null,
      };
    case "ERROR_GET_PARENT_ACCT_TRANSACTION":
      return {
        ...state,
        parentTransactionLoading: false,
        parentTransactionError: action.error,
        request: null,
      };
    case "REQUEST_CREATE_ACCT_TRANSACTION":
      return {
        ...state,
        request: action.payload.request,
        submitLoading: true,
        submitError: null,
        transactionID: "",
      };
    case "CREATE_ACCT_TRANSACTION_SUCCESS": {
      // Saved, but the re-read failed: leave the lists for the next fetch.
      if (!action.payload.transaction) {
        return {
          ...state,
          request: null,
          submitLoading: false,
          transactionID: action.payload.transactionID,
        };
      }
      const parentTransactionID =
        action.payload.transaction.parentTransactionID;
      const newPaymentTransaction = action.payload.transaction;

      // --- partnerTransactions (v1 detail page) ---
      const existingParentTransaction = state.partnerTransactions.find(
        (partner) => partner.id === parentTransactionID,
      );

      let updatedPartnerTransactions;
      if (existingParentTransaction) {
        const updatedItems = [
          ...existingParentTransaction.payments.items,
          newPaymentTransaction,
        ];
        const updatedParentTransaction = {
          ...existingParentTransaction,
          paid: getInvoiceBalance(existingParentTransaction.total, updatedItems)
            .isSettled,
          payments: {
            ...existingParentTransaction.payments,
            items: updatedItems,
          },
        };
        updatedPartnerTransactions = state.partnerTransactions.map((partner) =>
          partner.id === parentTransactionID
            ? updatedParentTransaction
            : partner,
        );
      } else {
        updatedPartnerTransactions = [...state.partnerTransactions];
      }

      updatedPartnerTransactions.unshift(newPaymentTransaction);

      // transactions list
      let updatedTransactions = [
        newPaymentTransaction,
        ...state.transactions,
      ].sort((a, b) => {
        if (a.createdAt > b.createdAt) return -1;
        if (a.createdAt < b.createdAt) return 1;
        return 0;
      });

      if (parentTransactionID) {
        updatedTransactions = updatedTransactions.map((t) => {
          if (t.id !== parentTransactionID) return t;
          const existingPayments = t.payments?.items || [];
          const newPayments = [...existingPayments, newPaymentTransaction];
          return {
            ...t,
            // The server's rule (payments >= total rounded to the rupiah), so
            // the list shows Lunas right away instead of after a reload.
            paid: getInvoiceBalance(t.total, newPayments).isSettled,
            payments: {
              ...(t.payments || {}),
              items: newPayments,
            },
          };
        });
      }

      // transaction detail (singular)
      let updatedTransaction = state.transaction;
      if (
        parentTransactionID &&
        state.transaction?.id === parentTransactionID
      ) {
        const existingPayments = state.transaction.payments?.items || [];
        const newPayments = [...existingPayments, newPaymentTransaction];
        updatedTransaction = {
          ...state.transaction,
          paid: getInvoiceBalance(state.transaction.total, newPayments)
            .isSettled,
          payments: {
            ...(state.transaction.payments || {}),
            items: newPayments,
          },
        };
      }

      return {
        ...state,
        request: null,
        submitLoading: false,
        partnerTransactions: updatedPartnerTransactions,
        transactionID: action.payload.transactionID,
        transactions: updatedTransactions,
        transaction: updatedTransaction,
      };
    }
    case "CREATE_ACCT_TRANSACTION_ERROR":
      return {
        ...state,
        request: null,
        submitLoading: false,
        submitError: action.error,
      };
    case "REQUEST_UPDATE_ACCT_TRANSACTION":
      return {
        ...state,
        request: action.payload.request,
        submitLoading: true,
        submitError: null,
        transactionID: "",
      };
    case "UPDATE_ACCT_TRANSACTION_SUCCESS":
      const { transactionID, transaction } = action.payload;
      const updatedTransactionsUpdate = state.transactions.map(
        (transactionItem) =>
          transactionItem.id === transaction?.id
            ? transaction
            : transactionItem,
      );
      return {
        ...state,
        request: null,
        submitLoading: false,
        transactionID,
        transactions: updatedTransactionsUpdate,
      };
    case "UPDATE_ACCT_TRANSACTION_ERROR":
      return {
        ...state,
        request: null,
        submitLoading: false,
        submitError: action.error,
      };
    case "REQUEST_DELETE_ACCT_TRANSACTION":
      return {
        ...state,
        request: action.payload.request,
        submitLoading: true,
        submitError: null,
        deletedID: "",
      };
    case "DELETE_ACCT_TRANSACTION_SUCCESS":
      const deletedTransactionID = action.payload.transactionID;

      const filteredTransactions = state.transactions.filter((transaction) => {
        return (
          transaction.id !== deletedTransactionID &&
          transaction.parentTransactionID !== deletedTransactionID
        );
      });

      const filteredPatnerTransactions = state.partnerTransactions
        .filter((partner) => {
          return (
            partner.id !== deletedTransactionID &&
            partner.parentTransactionID !== deletedTransactionID
          );
        })
        .map((partner) => {
          if (
            partner.payments &&
            partner.payments.items &&
            partner.payments.items.length > 0
          ) {
            partner.payments.items = partner.payments.items.filter(
              (item) => item.id !== deletedTransactionID,
            );
          }
          return partner;
        });

      return {
        ...state,
        request: null,
        submitLoading: false,
        deletedID: deletedTransactionID,
        transactions: filteredTransactions,
        partnerTransactions: filteredPatnerTransactions,
      };
    case "DELETE_ACCT_TRANSACTION_ERROR":
      return {
        ...state,
        request: null,
        submitLoading: false,
        submitError: action.error,
      };
    case "REQUEST_LIST_ACCOUNT_BALANCE":
      return {
        ...state,
        request: action.payload.request,
        balanceAccounts: [],
        balanceLoading: true,
        balanceError: null,
      };
    case "LIST_ACCOUNT_BALANCE_SUCCESS":
      return {
        ...state,
        request: null,
        balanceLoading: false,
        balanceAccounts: action.payload.items,
      };
    case "LIST_ACCOUNT_BALANCE_ERROR":
      return {
        ...state,
        request: null,
        balanceLoading: false,
        balanceError: action.error,
      };
    case "CLEAR_ACCOUNT_BALANCE":
      return {
        ...state,
        request: null,
        balanceAccounts: [],
        balanceError: null,
      };
    case "REQUEST_EXPORT_ACCOUNT_BALANCE":
      return {
        ...state,
        request: action.payload.request,
        balanceExportFile: {},
        balanceExportLoading: true,
        balanceExportError: null,
      };
    case "EXPORT_ACCOUNT_BALANCE_SUCCESS":
      return {
        ...state,
        request: null,
        balanceExportLoading: false,
        balanceExportFile: action.payload.file,
      };
    case "EXPORT_ACCOUNT_BALANCE_ERROR":
      return {
        ...state,
        request: null,
        balanceExportLoading: false,
        balanceExportError: action.error,
      };
    case "CLEAR_EXPORT_BALANCE":
      return {
        ...state,
        request: null,
        balanceExportFile: {},
        balanceExportError: null,
      };
    case "REQUEST_LIST_INCOME_STATEMENT":
      return {
        ...state,
        request: action.payload.request,
        incomeStatementAccounts: [],
        incomeStatementSummary: {},
        incomeStatementLoading: true,
        incomeStatementError: null,
      };
    case "LIST_INCOME_STATEMENT_SUCCESS":
      return {
        ...state,
        request: null,
        incomeStatementLoading: false,
        incomeStatementAccounts: action.payload.items,
        incomeStatementSummary: action.payload.summary,
      };
    case "LIST_INCOME_STATEMENT_ERROR":
      return {
        ...state,
        request: null,
        incomeStatementLoading: false,
        incomeStatementError: action.error,
      };
    case "REQUEST_EXPORT_INCOME_STATEMENT":
      return {
        ...state,
        request: action.payload.request,
        incomeExportFile: {},
        incomeExportLoading: true,
        incomeExportError: null,
      };
    case "EXPORT_INCOME_STATEMENT_SUCCESS":
      return {
        ...state,
        request: null,
        incomeExportLoading: false,
        incomeExportFile: action.payload.file,
      };
    case "EXPORT_INCOME_STATEMENT_ERROR":
      return {
        ...state,
        request: null,
        incomeExportLoading: false,
        incomeExportError: action.error,
      };
    case "CLEAR_EXPORT_INCOME_STATEMENT":
      return {
        ...state,
        request: null,
        incomeExportFile: {},
        incomeExportError: null,
      };
    case "REQUEST_VAT_RECAP":
      return {
        ...state,
        request: action.payload.request,
        vatRecapPeriod: action.payload.period,
        vatRecap: null,
        vatRecapLoading: true,
        vatRecapError: null,
      };
    // REST requests can't be cancelled, so a slower answer for a month the
    // user has already left can still land. Drop it rather than show it under
    // the newly picked month.
    case "VAT_RECAP_SUCCESS":
      if (action.payload.period !== state.vatRecapPeriod) return state;
      return {
        ...state,
        request: null,
        vatRecapLoading: false,
        vatRecap: action.payload.recap,
      };
    // A cancelled load was replaced by the next month's, which has already
    // set loading again — only the request handle is stale.
    case "VAT_RECAP_CANCEL":
      return state;
    case "VAT_RECAP_ERROR":
      if (action.payload?.period !== state.vatRecapPeriod) return state;
      return {
        ...state,
        request: null,
        vatRecapLoading: false,
        vatRecapError: action.error,
      };
    case "CLEAR_VAT_RECAP":
      return {
        ...state,
        vatRecap: null,
        vatRecapLoading: false,
        vatRecapError: null,
      };
    case "REQUEST_EXPORT_VAT_RECAP":
      return {
        ...state,
        request: action.payload.request,
        vatRecapExportFile: {},
        vatRecapExportLoading: true,
        vatRecapExportError: null,
      };
    case "EXPORT_VAT_RECAP_SUCCESS":
      return {
        ...state,
        request: null,
        vatRecapExportLoading: false,
        vatRecapExportFile: action.payload.file,
      };
    case "EXPORT_VAT_RECAP_ERROR":
      return {
        ...state,
        request: null,
        vatRecapExportLoading: false,
        vatRecapExportError: action.error,
      };
    case "CLEAR_EXPORT_VAT_RECAP":
      return {
        ...state,
        request: null,
        vatRecapExportFile: {},
        vatRecapExportError: null,
      };
    case "REQUEST_CASH_FLOW":
      return {
        ...state,
        request: action.payload.request,
        cashFlowItems: [],
        cashFlowTransactions: [],
        cashFlowTransactionsTotal: 0,
        cashFlowTransactionsTotalPages: 1,
        cashFlow: 0,
        previousCash: 0,
        cashFlowReconciled: true,
        cashFlowDifference: 0,
        cashFlowNonCash: [],
        cashFlowLoading: true,
        cashFlowError: null,
      };
    case "CASH_FLOW_SUCCESS":
      return {
        ...state,
        request: null,
        cashFlowLoading: false,
        cashFlowItems: action.payload.items,
        cashFlowTransactions: action.payload.transactions,
        cashFlowTransactionsTotal: action.payload.transactionsTotal,
        cashFlowTransactionsTotalPages: action.payload.transactionsTotalPages,
        cashFlow: action.payload.cashFlow,
        previousDate: action.payload.previousDate,
        previousCash: action.payload.previousCash,
        endDate: action.payload.endDate,
        endCash: action.payload.endCash,
        cashFlowReconciled: action.payload.reconciled,
        cashFlowDifference: action.payload.difference,
        cashFlowNonCash: action.payload.nonCashActivities || [],
      };
    case "CASH_FLOW_ERROR":
      return {
        ...state,
        request: null,
        cashFlowLoading: false,
        cashFlowError: action.error,
      };
    case "REQUEST_LIST_BALANCE_SHEET":
      return {
        ...state,
        request: action.payload.request,
        balanceSheets: [],
        balanceSheetsLoading: true,
        balanceSheetsError: null,
      };
    case "LIST_BALANCE_SHEET_SUCCESS":
      return {
        ...state,
        request: null,
        balanceSheetsLoading: false,
        balanceSheets: action.payload.items,
      };
    case "LIST_BALANCE_SHEET_ERROR":
      return {
        ...state,
        request: null,
        balanceSheetsLoading: false,
        balanceSheetsError: action.error,
      };
    case "REQUEST_EXPORT_BALANCE_SHEET":
      return {
        ...state,
        request: action.payload.request,
        balanceSheetExport: {},
        balanceSheetExportLoading: true,
        balanceSheetExportError: null,
      };
    case "EXPORT_BALANCE_SHEET_SUCCESS":
      return {
        ...state,
        request: null,
        balanceSheetExportLoading: false,
        balanceSheetExport: action.payload.file,
      };
    case "EXPORT_BALANCE_SHEET_ERROR":
      return {
        ...state,
        request: null,
        balanceSheetExportLoading: false,
        balanceSheetExportError: action.error,
      };
    case "CLEAR_EXPORT_BALANCE_SHEET":
      return {
        ...state,
        request: null,
        balanceSheetExport: {},
        balanceSheetExportError: null,
      };
    case "REQUEST_EXPORT_CASH_FLOW":
      return {
        ...state,
        request: action.payload.request,
        cashFlowExportFile: {},
        cashFlowExportLoading: true,
        cashFlowExportError: null,
      };
    case "EXPORT_CASH_FLOW_SUCCESS":
      return {
        ...state,
        request: null,
        cashFlowExportLoading: false,
        cashFlowExportFile: action.payload.file,
      };
    case "EXPORT_CASH_FLOW_ERROR":
      return {
        ...state,
        request: null,
        cashFlowExportLoading: false,
        cashFlowExportError: action.error,
      };
    case "CLEAR_EXPORT_CASH_FLOW":
      return {
        ...state,
        request: null,
        cashFlowExportFile: {},
        cashFlowExportError: null,
      };
    case "REQUEST_CAPITAL_STATEMENT":
      return {
        ...state,
        request: action.payload.request,
        capitalAccounts: [],
        capital: 0,
        netIncome: 0,
        capitalBeginning: 0,
        capitalRetainedPrior: 0,
        capitalNetIncomeCurrent: 0,
        capitalAdditions: 0,
        capitalWithdrawals: 0,
        capitalMatrix: null,
        capitalLoading: true,
        capitalError: null,
      };
    case "CAPITAL_STATEMENT_SUCCESS":
      return {
        ...state,
        request: null,
        capitalLoading: false,
        capital: action.payload.capital,
        netIncome: action.payload.netIncome,
        capitalAccounts: action.payload.items,
        capitalBeginning: action.payload.beginningCapital ?? 0,
        capitalRetainedPrior: action.payload.retainedEarningsPrior ?? 0,
        capitalNetIncomeCurrent: action.payload.netIncomeCurrent ?? 0,
        capitalAdditions: action.payload.additions ?? 0,
        capitalWithdrawals: action.payload.withdrawals ?? 0,
        capitalMatrix: action.payload.matrix ?? null,
      };
    case "CAPITAL_STATEMENT_ERROR":
      return {
        ...state,
        request: null,
        capitalLoading: false,
        capitalError: action.error,
      };
    case "REQUEST_EXPORT_CAPITAL_STATEMENT":
      return {
        ...state,
        request: action.payload.request,
        capitalExportFile: {},
        capitalExportLoading: true,
        capitalExportError: null,
      };
    case "REQUEST_UPLOAD_DOCUMENT_EXCEL":
      return {
        ...state,
        uploadLoading: true,
        uploadError: null,
        uploadSuccess: false,
        uploadRequest: null,
        storageRequest: null,
        excelUploadError: null,
        excelUploadClosedRows: null,
        excelUploadClosedThrough: null,
        excelUpload: {},
        uploadStatusError: false,
      };
    case "UPLOAD_DOCUMENT_EXCEL_PENDING":
      return {
        ...state,
        uploadLoading: true,
        uploadError: null,
        uploadSuccess: false,
        storageRequest: action.payload.upload,
        progressUpload: action.payload.progress,
        uploadStatusError: false,
      };
    case "UPLOAD_DOCUMENT_EXCEL_SUCCESS":
      return {
        ...state,
        uploadLoading: false,
        uploadSuccess: true,
        excelUpload: action.payload.excelUpload,
        excelUploadError: action.payload.excelUploadError,
        // The chart-of-accounts upload dispatches this same action type without
        // any period fields, so these fall back to null rather than leaving a
        // previous transaction upload's rows marked on an unrelated table.
        excelUploadClosedRows: action.payload.excelUploadClosedRows || null,
        excelUploadClosedThrough:
          action.payload.excelUploadClosedThrough || null,
      };
    case "UPLOAD_DOCUMENT_EXCEL_ERROR":
      return {
        ...state,
        uploadLoading: false,
        uploadError: action.error,
        uploadStatusError: true,
      };
    case "DELETE_DRAFT_ACCT_TRANSACTION_IMPORT":
      return {
        ...state,
        excelUpload: {
          ...state.excelUpload,
          transactions: state.excelUpload?.transactions?.filter(
            (item) => item.id !== action.payload.accountingTransactiontId,
          ),
        },
        draftImport: {
          ...state.draftImport,
          transactions: state.draftImport?.transactions?.filter(
            (item) => item.id !== action.payload.accountingTransactiontId,
          ),
        },
      };
    case "EDIT_DRAFT_ACCT_TRANSACTION_IMPORT":
      const { draftItem } = action.payload;
      return {
        ...state,
        excelUpload: {
          ...state.excelUpload,
          transactions: state.excelUpload?.transactions?.map((item) =>
            item.id === draftItem.id ? draftItem : item,
          ),
        },
        draftImport: {
          ...state.draftImport,
          transactions: state.draftImport?.transactions?.map((item) =>
            item.id === draftItem.id ? draftItem : item,
          ),
        },
      };
    case "REQUEST_CREATE_EXCEL_ACCOUNT":
      return {
        ...state,
        excelAccounts: [],
        excelAccountsLoading: true,
        excelAccountsSuccess: false,
        excelAccountsError: null,
      };
    case "SUCCESS_CREATE_EXCEL_ACCOUNT":
      return {
        ...state,
        excelAccounts: action.payload.excelAccounts,
        excelAccountsSuccess: true,
        excelAccountsLoading: false,
      };
    case "ERROR_CREATE_EXCEL_ACCOUNT":
      return {
        ...state,
        excelAccountsError: action.error,
        excelAccountsLoading: false,
      };
    case "CLEAR_UPLOAD_DOCUMENT_EXCEL":
      return {
        ...state,
        excelUpload: [],
        uploadSuccess: false,
        excelUploadError: null,
        excelUploadClosedRows: null,
        excelUploadClosedThrough: null,
      };
    case "CLEAR_CREATE_EXCEL_ACCOUNT":
      return {
        ...state,
        excelAccounts: [],
        excelAccountsSuccess: false,
      };
    case "CLEAR_EXCEL_ACCOUNT_ERROR":
      return {
        ...state,
        excelAccountsError: null,
        uploadError: null,
      };
    case "CLEAR_UPLOAD_STATUS_DOCUMENT_EXCEL":
      return {
        ...state,
        uploadSuccess: false,
        uploadStatusError: false,
      };
    case "EXPORT_CAPITAL_STATEMENT_SUCCESS":
      return {
        ...state,
        request: null,
        capitalExportLoading: false,
        capitalExportFile: action.payload.file,
      };
    case "EXPORT_CAPITAL_STATEMENT_ERROR":
      return {
        ...state,
        request: null,
        capitalExportLoading: false,
        capitalExportError: action.error,
      };
    case "CLEAR_EXPORT_CAPITAL_STATEMENT":
      return {
        ...state,
        request: null,
        capitalExportFile: {},
        capitalExportError: null,
      };
    case "CLEAR_ACCOUNTING_ACCOUNT":
      return {
        ...state,
        accountID: "",
        deletedID: "",
      };
    case "CLEAR_ACCT_ACCOUNT_ERROR":
      return {
        ...state,
        deleteError: null,
        submitError: null,
        inputError: null,
      };
    case "REQUEST_LIST_PARTNER_TRANSACTION":
      return {
        ...state,
        partnerTransactionsLoading: true,
        partnerTransactionsError: null,
        partnerTransactions: [],
        request: action.payload.request,
        partnerTransactionsNextTokens:
          action.payload.page === 1
            ? initialState.partnerTransactionsNextTokens
            : state.partnerTransactionsNextTokens,
      };
    case "SUCCESS_LIST_PARTNER_TRANSACTION":
      return {
        ...state,
        partnerTransactionsLoading: false,
        partnerTransactions: action.payload.items,
        partnerTransactionsNextTokens: {
          ...state.partnerTransactionsNextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
      };
    case "ERROR_LIST_PARTNER_TRANSACTION":
      return {
        ...state,
        partnerTransactionsLoading: false,
        partnerTransactionsError: action.payload.error,
      };
    case "REQUEST_CREATE_INVOICE_TRANSACTION":
      return {
        ...state,
        request: action.payload.request,
        newInvoiceID: "",
        newInvoiceLoading: true,
        newInvoiceError: null,
      };
    case "CREATE_INVOICE_TRANSACTION_SUCCESS":
      return {
        ...state,
        request: null,
        newInvoiceID: action.payload.transactionID,
        // Null when the save went through but the re-read failed.
        transactions: action.payload.invoice
          ? [action.payload.invoice, ...state.transactions]
          : state.transactions,
        newInvoiceLoading: false,
      };
    case "CREATE_INVOICE_TRANSACTION_ERROR":
      return {
        ...state,
        request: null,
        newInvoiceLoading: false,
        newInvoiceError: action.error,
      };
    case "REQUEST_UPDATE_INVOICE_TRANSACTION":
      return {
        ...state,
        request: action.payload.request,
        invoiceID: "",
        submitLoading: true,
        submitError: null,
      };
    case "UPDATE_INVOICE_TRANSACTION_SUCCESS":
      const { invoiceID, invoice } = action.payload;
      const updatedTransactions = state.transactions.map((transaction) =>
        transaction.id === invoice?.id ? invoice : transaction,
      );
      return {
        ...state,
        request: null,
        invoiceID,
        submitLoading: false,
        transactions: updatedTransactions,
      };
    case "UPDATE_INVOICE_TRANSACTION_ERROR":
      return {
        ...state,
        request: null,
        submitLoading: false,
        submitError: action.error,
      };
    case "REQUEST_DOWNLOAD_INVOICE":
      return {
        ...state,
        request: action.payload.request,
        downloadInvoice: {},
        downloadInvoiceLoading: true,
        downloadInvoiceError: null,
      };
    case "DOWNLOAD_INVOICE_SUCCESS":
      return {
        ...state,
        request: null,
        downloadInvoiceLoading: false,
        downloadInvoice: action.payload.file,
      };
    case "DOWNLOAD_INVOICE_ERROR":
      return {
        ...state,
        request: null,
        downloadInvoiceLoading: false,
        downloadInvoiceError: action.error,
      };
    case "CLEAR_INVOICE_TRANSACTION":
      return {
        ...state,
        newInvoiceID: "",
        invoiceID: "",
      };
    case "CLEAR_DOWNLOAD_INVOICE":
      return {
        ...state,
        request: null,
        downloadInvoice: {},
        downloadInvoiceError: null,
      };
    case "CLEAR_INVOICE_TRANSACTION_ERROR":
      return {
        ...state,
        newInvoiceError: null,
        submitError: null,
      };
    case "REQUEST_UPDATE_OPENING_BALANCE":
      return {
        ...state,
        request: action.payload.request,
        submitLoading: true,
        submitError: null,
      };
    case "UPDATE_OPENING_BALANCE_SUCCESS":
      return {
        ...state,
        request: null,
        submitLoading: false,
        transactionID: action.payload.transactionID,
      };
    case "UPDATE_OPENING_BALANCE_ERROR":
      return {
        ...state,
        request: null,
        submitLoading: false,
        submitError: action.error,
      };
    case "CLEAR_UPDATE_OPENING_BALANCE":
      return {
        ...state,
        request: null,
        transactionID: "",
        submitError: null,
      };
    case "REQUEST_ACOUNTING_SUMMARY":
      return {
        ...state,
        request: action.payload.request,
        accountingSummary: {},
        accountingSummaryLoading: true,
        accountingSummaryError: null,
      };
    case "ACOUNTING_SUMMARY_SUCCESS":
      return {
        ...state,
        request: null,
        accountingSummaryLoading: false,
        accountingSummary: action.payload.accountingSummary,
      };
    case "ACOUNTING_SUMMARY_ERROR":
      return {
        ...state,
        request: null,
        accountingSummaryLoading: false,
        accountingSummaryError: action.error,
      };
    case "REQUEST_EXPORT_GENERAL_JOURNAL":
      return {
        ...state,
        request: action.payload.request,
        generalJournalFile: {},
        generalJournalFileLoading: true,
        generalJournalFileError: null,
      };
    case "EXPORT_GENERAL_JOURNAL_SUCCESS":
      return {
        ...state,
        request: null,
        generalJournalFileLoading: false,
        generalJournalFile: action.payload.file,
      };
    case "EXPORT_GENERAL_JOURNAL_ERROR":
      return {
        ...state,
        request: null,
        generalJournalFileLoading: false,
        generalJournalFileError: action.error,
      };
    // Kept apart from `request` so the list and the totals can be cancelled
    // independently.
    case "REQUEST_GENERAL_JOURNAL_SUMMARY":
      return {
        ...state,
        generalJournalSummaryRequest: action.payload.request,
        generalJournalSummary: null,
        generalJournalSummaryLoading: true,
        generalJournalSummaryError: null,
      };
    // REST requests can't actually be cancelled, so totals for a range the
    // user already left can still arrive. Only the latest request may land.
    case "GENERAL_JOURNAL_SUMMARY_SUCCESS":
      if (action.payload.request !== state.generalJournalSummaryRequest) {
        return state;
      }
      return {
        ...state,
        generalJournalSummaryRequest: null,
        generalJournalSummaryLoading: false,
        generalJournalSummary: action.payload.summary,
      };
    case "GENERAL_JOURNAL_SUMMARY_ERROR":
      if (action.payload?.request !== state.generalJournalSummaryRequest) {
        return state;
      }
      return {
        ...state,
        generalJournalSummaryRequest: null,
        generalJournalSummaryLoading: false,
        generalJournalSummaryError: action.error,
      };
    case "CLEAR_EXPORT_GENERAL_JOURNAL":
      return {
        ...state,
        request: null,
        generalJournalFile: {},
        generalJournalFileLoading: false,
        generalJournalFileError: null,
      };
    case "REQUEST_CREATE_EXCEL_TRANSACTION":
      return {
        ...state,
        excelTransactions: [],
        excelTransactionsLoading: true,
        excelAccountsSuccess: false,
        excelAccountsError: null,
      };
    case "SUCCESS_CREATE_EXCEL_TRANSACTION":
      return {
        ...state,
        excelTransactions: action.payload.excelTransactions,
        excelTransactionsSuccess: true,
        excelTransactionsLoading: false,
      };
    case "ERROR_CREATE_EXCEL_TRANSACTION":
      return {
        ...state,
        excelTransactionsError: action.error,
        excelTransactionsLoading: false,
      };
    case "CLEAR_CREATE_EXCEL_TRANSACTION":
      return {
        ...state,
        excelTransactions: [],
        excelTransactionsSuccess: false,
        excelTransactionsError: null,
      };
    case "SET_ACCT_TRANSACTION_INITIAL_DATA":
      return {
        ...state,
        transactionInitialData: action.payload.transactionInitialData,
      };
    case "REQUEST_GET_ACCOUNTING_TRANSACTION_IMPORT":
      return {
        ...state,
        request: action.payload.request,
        draftImport: {},
        draftImportLoading: true,
        draftImportError: null,
      };
    case "GET_ACCOUNTING_TRANSACTION_IMPORT_SUCCESS":
      return {
        ...state,
        request: null,
        draftImport: action.payload.draftImport,
        draftImportLoading: false,
      };
    case "GET_ACCOUNTING_TRANSACTION_IMPORT_ERROR":
      return {
        ...state,
        request: null,
        draftImportLoading: false,
        draftImportError: action.error,
      };
    case "REQUEST_LIST_ACCOUNTING_TRANSACTION_IMPORT":
      return {
        ...state,
        request: action.payload.request,
        draftImports: [],
        nextTokens:
          action.payload.page === 1
            ? initialState.nextTokens
            : state.nextTokens,
        nextToken: null,
        draftImportsLoading: true,
        draftImportsError: null,
      };
    case "SUCCESS_LIST_ACCOUNTING_TRANSACTION_IMPORT":
      return {
        ...state,
        request: null,
        draftImports: action.payload.items,
        nextTokens: {
          ...state.nextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
        draftImportsLoading: false,
      };
    case "ERROR_LIST_ACCOUNTING_TRANSACTION_IMPORT":
      return {
        ...state,
        request: null,
        draftImportsLoading: false,
        draftImportsError: action.error,
      };
    case "REQUEST_GET_INCOME_STATS":
      return {
        ...state,
        request: action.payload.request,
        incomeStats: {},
        incomeStatsLoading: true,
        incomeStatsError: null,
      };
    case "GET_INCOME_STATS_SUCCESS":
      return {
        ...state,
        request: null,
        incomeStats: action.payload.incomeStats,
        incomeStatsLoading: false,
      };
    case "GET_INCOME_STATS_ERROR":
      return {
        ...state,
        request: null,
        incomeStatsLoading: false,
        incomeStatsError: action.payload.error,
      };
    case "REQUEST_GET_EXPENSE_STATS":
      return {
        ...state,
        request: action.payload.request,
        expenseStats: {},
        expenseStatsLoading: true,
        expenseStatsError: null,
      };
    case "GET_EXPENSE_STATS_SUCCESS":
      return {
        ...state,
        request: null,
        expenseStats: action.payload.expenseStats,
        expenseStatsLoading: false,
      };
    case "GET_EXPENSE_STATS_ERROR":
      return {
        ...state,
        request: null,
        expenseStatsLoading: false,
        expenseStatsError: action.payload.error,
      };
    case "REQUEST_GET_ACCOUNTING_STATS":
      return {
        ...state,
        request: action.payload.request,
        accountingStats: {},
        accountingStatsError: null,
        accountingStatsLoading: true,
      };
    case "GET_ACCOUNTING_STATS_SUCCESS":
      return {
        ...state,
        request: null,
        accountingStats: action.payload.stats,
        accountingStatsLoading: false,
      };
    case "GET_ACCOUNTING_STATS_ERROR":
      return {
        ...state,
        request: null,
        accountingStatsLoading: false,
        accountingStatsError: action.payload.error,
      };
    case "REQUEST_GET_CASHFLOW":
      return {
        ...state,
        request: action.payload.request,
        cashFlows: {},
        cashFlowsError: null,
        cashFlowsLoading: true,
      };
    case "GET_CASHFLOW_SUCCESS":
      return {
        ...state,
        request: null,
        cashFlows: action.payload.cashFlows,
        cashFlowsLoading: false,
      };
    case "GET_CASHFLOW_ERROR":
      return {
        ...state,
        request: null,
        cashFlowsLoading: false,
        cashFlowsError: action.payload.error,
      };
    case "REQUEST_LIST_ACCOUNT_TRANSACTION":
      return {
        ...state,
        request: action.payload.request,
        accountTransactionsLoading: true,
        accountTransactionsError: null,
        accountTransactions: [],
        accountTransactionNextTokens:
          action.payload.page === 1
            ? initialState.accountTransactionNextTokens
            : state.accountTransactionNextTokens,
      };
    case "SUCCESS_LIST_ACCOUNT_TRANSACTION":
      return {
        ...state,
        request: null,
        accountTransactionsLoading: false,
        accountTransactionsError: null,
        accountTransactions: action.payload.items,
        accountTransactionNextTokens: {
          ...state.accountTransactionNextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
      };
    case "ERROR_LIST_ACCOUNT_TRANSACTION":
      return {
        ...state,
        request: null,
        accountTransactionsLoading: false,
        accountTransactionsError: action.error,
      };
    case "CLEAR_ACCOUNT_TRANSACTION":
      return {
        ...state,
        accountTransactions: [],
      };
    case "CLEAR_ACCOUNT_TRANSACTION_ERROR":
      return {
        ...state,
        accountTransactionsError: null,
      };
    case "REQUEST_GET_ACCOUNT_BALANCE":
      // Drop the previous page's balances: the CoA list filters rows by them.
      return {
        ...state,
        accountBalances: {},
        accountBalancesLoading: true,
        accountBalancesError: null,
      };
    case "GET_ACCOUNT_BALANCE_SUCCESS":
      return {
        ...state,
        accountBalancesLoading: false,
        accountBalances: action.payload.accountBalances,
      };
    case "GET_ACCOUNT_BALANCE_ERROR":
      return {
        ...state,
        accountBalances: {},
        accountBalancesLoading: false,
        accountBalancesError: action.error,
      };
    case "CLEAR_ACCOUNT_BALANCE_DATA":
      return {
        ...state,
        accountBalances: {},
        accountBalancesLoading: false,
        accountBalancesError: null,
      };
    case "REQUEST_PERIOD_STATUS":
      // Keeps any cached entry so a refetch doesn't blink the lock banner off.
      return {
        ...state,
        periodLoading: true,
        periodError: null,
      };
    case "PERIOD_STATUS_SUCCESS": {
      const { businessID, status } = action.payload;
      const { history, ...rest } = status || {};
      return {
        ...state,
        periodLoading: false,
        periodStatus: { ...state.periodStatus, [businessID]: rest },
        periodHistory: {
          ...state.periodHistory,
          [businessID]: Array.isArray(history) ? history : [],
        },
      };
    }
    case "PERIOD_STATUS_ERROR":
      // Never drop periodStatus here: a failed refresh must not silently report
      // a closed book as open and re-enable every write control.
      return {
        ...state,
        periodLoading: false,
        periodError: action.error,
      };
    case "REQUEST_CLOSE_PERIOD":
      return {
        ...state,
        closePeriodLoading: true,
        closePeriodError: null,
        closePeriodResult: null,
      };
    case "CLOSE_PERIOD_SUCCESS": {
      const { businessID, result } = action.payload;
      const cached = state.periodStatus[businessID];
      return {
        ...state,
        closePeriodLoading: false,
        closePeriodResult: result,
        // Patch the cached boundary in place so banners and date pickers already
        // mounted elsewhere are correct without waiting for a refetch.
        periodStatus: cached
          ? {
              ...state.periodStatus,
              [businessID]: { ...cached, closedThrough: result?.closedThrough },
            }
          : state.periodStatus,
      };
    }
    case "CLOSE_PERIOD_ERROR":
      return {
        ...state,
        closePeriodLoading: false,
        closePeriodError: action.error,
      };
    case "REQUEST_REOPEN_PERIOD":
      return {
        ...state,
        reopenPeriodLoading: true,
        reopenPeriodError: null,
        reopenPeriodResult: null,
      };
    case "REOPEN_PERIOD_SUCCESS": {
      const { businessID, result } = action.payload;
      const cached = state.periodStatus[businessID];
      return {
        ...state,
        reopenPeriodLoading: false,
        reopenPeriodResult: result,
        periodStatus: cached
          ? {
              ...state.periodStatus,
              // A full reopen answers closedThrough: null — coerce undefined to
              // null so the lock actually clears.
              [businessID]: {
                ...cached,
                closedThrough: result?.closedThrough ?? null,
              },
            }
          : state.periodStatus,
      };
    }
    case "REOPEN_PERIOD_ERROR":
      return {
        ...state,
        reopenPeriodLoading: false,
        reopenPeriodError: action.error,
      };
    case "CLEAR_PERIOD_RESULT":
      return {
        ...state,
        closePeriodError: null,
        closePeriodResult: null,
        reopenPeriodError: null,
        reopenPeriodResult: null,
      };
    // A save abandoned mid-flight (its modal closed). Without a case here its
    // loading flag stayed on and the next open showed a spinning button.
    case "CREATE_INVOICE_TRANSACTION_CANCEL":
      return {
        ...state,
        request: null,
        newInvoiceLoading: false,
      };
    case "UPDATE_INVOICE_TRANSACTION_CANCEL":
      return {
        ...state,
        request: null,
        submitLoading: false,
      };
    default:
      return state;
  }
};
